import { SKELETON_DARK } from '@/constants/skeleton';
import { TILE_LAYOUT_CLASSES_NORMAL_WIDTH_BASIS, TILE_LAYOUT_CLASSES_PADDING } from '@/constants/tileGridLayout';
interface PlaceholderSliderCarouselProps {
  numberOfSlides?: number;
}
export const SliderSkeleton = ({
  numberOfSlides = 10
}: PlaceholderSliderCarouselProps) => {
  const carouselItemClasses = `${TILE_LAYOUT_CLASSES_NORMAL_WIDTH_BASIS} ${TILE_LAYOUT_CLASSES_PADDING} pl-0`;
  return <div className={'pointer-events-none'} suppressHydrationWarning data-sentry-component="SliderSkeleton" data-sentry-source-file="SliderSkeleton.tsx">
      {/* Placeholder carousel title */}
      <span className={`placeholder ${SKELETON_DARK} mx-[clamp(1.5rem,3cqw,3rem)] mt-[5px] mb-[0.75rem] block h-[24px] w-[120px]`} suppressHydrationWarning />
      <div className="group/carousel @container fl-mb-8/10 relative">
        <div className="relative">
          <div className="overflow-hidden">
            <div className="mx-container mr-container ml-container flex">
              {new Array(numberOfSlides).fill(null).map((_, i) =>
            // eslint-disable-next-line react/no-array-index-key, @eslint-react/no-array-index-key
            <div className={`min-w-0 shrink-0 grow-0 ${carouselItemClasses}`} key={i}>
                  {/* Placeholder carousel title image */}
                  <div className={`placeholder ${SKELETON_DARK} aspect-square`} suppressHydrationWarning />
                  {/* Placeholder tile name */}
                  <span className={`placeholder ${SKELETON_DARK} mt-4 mb-[0.75rem] block h-[17px] w-[66%]`} suppressHydrationWarning />
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </div>;
};